import React, { useMemo } from 'react';
import moment from 'moment';
import { ReactTable } from '../../../../shared/ReactTable';
import { TABLE_TYPES } from '../../utils';
import '../../RfController.css';

const RfControllerDirectionTable = ({ data, columns }) => {
  const localTimeZone = moment.tz.guess();

  const formattedDirectionData = useMemo(() => {
    const formattedData = [];
    data &&
      data.forEach((targetRowData) => {
        let localTimeFormatted = 'N/A';

        if (targetRowData.lastUpdated != null) {
          let utcTime = targetRowData.lastUpdated;
          let localTime = moment.utc(utcTime).tz(localTimeZone);
          localTimeFormatted = localTime.format('MMM Do YYYY, hh:mm:ss a');
        }

        formattedData.push({
          parameter: { name: targetRowData.parameter, hoverMessage: targetRowData.hoverMessage },
          minMax:
            (targetRowData.min ? (targetRowData.min > 0 ? '+' + targetRowData.min : targetRowData.min) : '') +
            '/' +
            (targetRowData.max ? (targetRowData.max > 0 ? '+' + targetRowData.max : targetRowData.max) : ''),
          currentValue: targetRowData.currentValue,
          lastUpdated: localTimeFormatted
        });
      });
    return formattedData;
  }, [data, localTimeZone]);

  return (
    <ReactTable
      className={'DirectionTable Global_Table'}
      noDataText={'Fetching Data...'}
      showPagination={false}
      resizable={false}
      pageSize={2}
      getTdProps={(state, rowInfo, column, instance) => {
        return {
          onClick: (e, handleOriginal) => {
            if (handleOriginal) {
              handleOriginal(); /* Suggested by documentation, makes sure that default click functions still get called if necessary*/
            }
          }
        };
      }}
      data={formattedDirectionData}
      columns={columns}
      getProps={() => {
        return { id: TABLE_TYPES.DIRECTION };
      }}
    />
  );
};

export default RfControllerDirectionTable;
